export default {
  notice: {
    progress: '{done} von {total} Orten markiert',
    participation_hint: 'Nur noch wenige Schritte, um deine Orte abzuschließen.',
    participation_unfinished: 'Deine Teilnahme ist noch nicht abgeschlossen'
  },
  home_tiles: {
    preset_demo: 'Empfohlen',
    preset_weide: 'Wiese',
    preset_app: 'App',
    preset_speels: 'Verspielt',
    layout_game: 'Spiel',
    layout_poster: 'Poster',
    depth_demo: 'Tiefe',
    depth_flat: 'Flach',
    depth_soft: 'Sanft',
    depth_deep: 'Tief',
    demo_panel: 'Demo-Optionen',
    notice_demo: 'Teilnahme-Hinweis',
    notice_progress: 'Fortschritt',
    notice_bold: 'Auffällig',
    notice_boldprogress: 'Auffällig + Fortschritt',
    notice_boldfull: 'Auffällig + Text + Fortschritt',
    bg_demo: 'Hintergrund',
    bg_plain: 'Weiß',
    bg_soft: 'Sanft',
    bg_meadow: 'Wiese',
    banner_welcome: 'Willkommen',
    layout_welcome: 'Willkommen',
    welcome_intro: 'Du folgst {communities} Communities und hast {areas} Gebiete markiert.',
    banner_demo: 'Kopf',
    banner_solid: 'Fläche',
    banner_photo: 'Foto',
    banner_minimal: 'Minimal',
    banner_pass: 'Mitgliedskarte',
    areas_count: '{count} Gebiete',
    communities_count: '{count} Communities',
    budget_line: '{amount} Budget · {pct}% zugesagt',
    layout_demo: 'Kachel-Layout',
    layout_inline: 'Inline',
    layout_icon: 'Icon',
    layout_compact: 'Kompakt',
    subscribers: '{count} Abonnenten',
    hello: 'Hallo {name}',
    notifications: 'Benachrichtigungen',
    unread: '{count} ungelesen',
    all_read: 'Alles gelesen',
    no_messages: 'Noch keine Nachrichten',
    see_all: 'Alle anzeigen',
    budget: 'Budget',
    pledged: 'zugesagt',
    no_budget: 'Noch kein Naturbudget',
    no_areas: 'Noch keine Gebiete. Markiere Orte, die dir wichtig sind, auf der Karte.',
    no_communities: 'Du folgst noch keiner Community.',
    browse_map: 'Karte ansehen'
  },
  theme: {
    title: 'Design',
    modern_light: 'Hell',
    modern_dark: 'Dunkel',
    neon: 'Neon',
    glass: 'Glas'
  },
  messages: {
    // account_created: 'Please check your email to verify your registration. This sometimes can take up to 10 minutes. Please check the spam folder if the email has not been received.',
    // password_forgot: 'Please check your email to reset your password.',
    // verification_success: 'Your e-mail has been verified. You can now login.',
    // verification_failed: 'Verification has failed.',
    // password_recover_success: 'Your password has been reset. You can now login with the new password.',
    // logout_confirmation: 'Are you sure you want to log out?',
    // confirm: 'Confirm',
    // update_available: 'A new update is available. Click on ok to reload the page.',
    // account_signed_out: 'You have been signed out',
    // account_updated: 'Account succesfully updated'
    account_created: 'Account erstellt',
    password_forgot: 'Bitte schauen Sie in Ihre E-Mail um Ihr Passwort zurück zusetzen',
    account_signed_out: 'Sie wurden ausgeloggt',
    account_updated: 'Account aktualisiert',
    verification_success: 'Ihre E-Mail ist verifiziert. Sie können sich nun einloggen.',
    verification_failed: 'Verifikation missglückt',
    password_recover_success: 'Ihr Passwort wurde zurückgesetzt. Sie können sich nun mit dem neuen Passwort anmelden.',
    logout_confirmation: 'Sind Sie sicher, dass Sie sich ausloggen wollen?',
    login_confirmation: 'Sie haben sich erfolgreich wieder eingeloggt. Willkommen zurück!',
    login_failed: 'E-Mail- und Passwortkombination nicht erkannt',
    confirm: 'Bestätigen',
    update_available: 'Ein neues Update ist verfügbar. Klicken Sie auf OK um die Seite neu zu laden.',
    url_copied_to_clipboard: 'Der Karten-URL wurde in die Zwischenablage kopiert.',
    add_area_account_required: 'Um ein neues Gebiet hinzuzufügen, brauchen Sie einen Account.',
    area_deleted: 'Gebiet wurde gelöscht.',
    area_updated: 'Gebiet wurde aktualisiert',
    unsubscribed: 'Sie haben sich von der Community abgemeldet.',
    subscribed: 'Sie sind nun Teil dieser Community',
    thread_created: 'Eine neue Diskussion wurde erstellt.',
    thread_updated: 'Die Diskussion wurde aktualisiert',
    comment_created: 'Sie haben eine Antwort gepostet',
    comment_reported: 'Das Bild wurde an die Moderation gemeldet',
    comment_unreported: 'Dieser Inhalt wurde von dem/der Moderator*in gelöscht.',
    comment_deleted: 'Dieser Inhalt wurde gelöscht.',
    community_updated: 'Diese Community wurde aktualisiert.',
    RMS_send: 'Moderator*in-anfrage gesendet',
    poll_created: 'Umfrage erstellt',
    polis_created: 'Polis erstellt',
    meeting_created: 'Treffen erstellt',
    meeting_invite_accepted: 'Sie haben die Einladung angenommen.',
    meeting_invite_declined: 'Sie haben die Einladung abgelehnt.',
    pledge_funding_completed: 'Virtueller Finanzierungsbetrag erfolgreich abgeschlossen.',
    pledge_added: 'Danke für Ihren Beitrag von € '
  },
  errors: {
    general_error: 'Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.',
    not_found: 'Entschuldigung, hier ist leider nichts...',
    network: 'Netzwerkfehler. Bitte überprüfen Sie Ihre Internetverbindung.',
    // fields: 'Please correct the input fields',
    required: 'Pflichtfeld',
    register: {
      password_length: 'Das Passwort muss mindestens {length} Zeichen lang sein.',
      password_match: 'Passwörter stimmen nicht überein.',
      email_valid: 'Bitte benutzen Sie eine gültige E-Mail Adresse.',
      name_length: ' Benutzer*innenname muss zwischen {minLength} und {maxLength} Zeichen lang sein.',
      organization_length: 'Name der Organisation muss zwischen {minLength} und {maxLength} Zeichen lang sein.'
    }
  },
  buttons: {
    pledge: 'Mittel zusagen',
    ok: 'Ok',
    submit: 'Übermitteln',
    logout: 'Ausloggen',
    cancel: 'Abbrechen',
    login: 'Einloggen',
    register: 'Übermitteln',
    // Finn's Comment: I don't quite know where submit is used...
    // go_back: 'Zurück',
    send: 'Senden',
    reSend: 'Erneut senden',
    close: 'Schließen',
    previous: 'Zurück',
    save: 'Speichern',
    create: 'Erstellen',
    update: 'Aktualisieren',
    delete: 'Löschen',
    subscribe: 'Abonnieren',
    unsubscribe: 'Abbestellen',
    next: 'Weiter',
    continue: 'Weiter',
    back: 'Zurück',
    add: 'Hinzufügen',
    edit: 'Bearbeiten',
    reply: 'Antworten',
    report: 'Melden',
    unreport: 'Melden zurückziehen',
    goto_authenticate: 'Zum Log-in',
    stop: 'Stop',
    pauze: 'Pause',
    continue_register: 'Registrierung fortführen',
    continue_participation: 'Beteiligung fortführen',
    become_moderator: 'Moderator*in werden',
    add_image: 'Bild hinzufügen',
    accept: 'Annehmen',
    decline: 'Ablehnen',
    reset: 'Zurücksetzen',
    discard: 'Verwerfen'
  },
  headers: {
    login: 'Einloggen',
    register: 'Registrieren',
    password_forgot: 'Neues Passwort anfragen',
    password_recover: 'Passwort zurücksetzen',
    administrator: 'Administrator*in',
    navigation: 'Navigation',
    my_overview: 'Meine Übersicht',
    overview: 'Übersicht',
    users: 'Benutzer',
    communities: 'Communities'
  },
  activities: {
    act_cycl: {
      title: 'Fahrrad fahren',
      desciption: 'TODO' // Finn's Comment: TODO as in To-do? There isn't really a good translation for that.

    },
    act_walk: {
      title: 'Wandern oder Joggen',
      desciption: 'TODO'
    },
    act_tour: {
      title: 'Mit dem Auto oder Motorrad herumfahren',
      desciption: 'TODO'
    },
    act_natu: {
      title: 'Natur beobachten',
      desciption: 'TODO'
    },
    act_water: {
      title: 'Wassersport',
      desciption: 'TODO'
    },
    act_play: {
      title: 'Spielen oder Sitzen',
      desciption: 'TODO'
    },
    act_wintr: {
      title: 'Wintersport',
      desciption: 'TODO'
    },
    act_mount: {
      title: 'Bergsteigen',
      desciption: 'TODO'
    }
  },
  labels: {
    account_required: 'Account erforderlich',
    read_more: 'Mehr lesen',
    'area_create_button': 'Speichern',
    'area_update_button': 'Speichern',
    'area_created_succes': 'Gebiet erfolgreich hinzugefügt',
    'area_updated_succes': 'Gebiet erfolgreich aktualisiert',
    'community_created_succes': 'Community wurde erfolgreich erstellt',
    agree_disclaimer: 'Ich stimme den Geschäftsbedingungen zu.',
    my_account: 'Mein Account',
    register: 'Account erstellen',
    logout: 'Ausloggen',
    login: 'Einloggen',
    email: 'E-Mail Adresse',
    name: 'Benutzer*innenname',
    companyName: 'Firmenname',
    organization: 'Name der Organisation',
    sector: 'Sektor',
    address: 'Addresse',
    address_search: 'Wohnort',
    // zipcodeCompany: 'Zipcode headquarter',
    website: 'Webseite',
    city: 'Stadt',
    // cityCompany: 'City headquarter',
    age: 'Altersgruppe',
    education: 'Bildungsgrad',
    gender: 'Geschlecht',
    type: 'Typ',
    password: 'Passwort',
    repeat_password: 'Passwort wiederholen',
    remember_me: 'Angemeldet bleiben',
    password_forgot: 'Haben Sie ihr Passwort vergessen?',
    home: 'Zuhause',
    here: 'Hier',
    // Finn's Comment: Don't quite know where that goes...
    neighbourhood: 'Nachbarschaft',
    'living-area': 'Region',
    country: 'Land',
    worldwide: 'Weltweit',
    share_this_area: 'Dieses Gebiet teilen',
    share_this_community: 'Diese Community teilen',
    subscribed: 'Aboniert',
    reply: 'Antworten',
    comment: 'Kommentieren',
    finish: 'Abschließen',
    readmore: 'Mehr lesen',
    search: 'Suchen',
    created_on: 'Erstellt am',
    dear: 'Am besten',
    karma: 'Schicksal'
  },
  pages: {
    home: {
      title: 'Heim'
    },
    moderators: {
      title: 'Moderator*innen',
      mod_requests: 'Moderator*innen-Anfragen',
      mods: 'Moderator*innen'
    },
    create_community: {
      title: 'Community erstellen'
    },
    land_owner_register: {
      title: 'Registrierung für Landbesitzer*innen',
      steps: {
        general: {
          nav_title: ' Allgemeine Informationen',
          title: 'Information Landbesitzer*innen',
          task_title: 'Fügen Sie allgemeine Informationen über das Land was Sie besitzen hinzu.',
          email: 'E-Mail'
        },
        draw: {
          nav_title: 'Karte',
          title: 'Gebiet zeichnen',
          task_title: 'Zeichnen Sie Ihr Gebiet ein'
        },
        description: {
          nav_title: 'Beschreibung',
          title: 'Beschreiben Sie ihre Community',
          task_title: 'Fügen Sie einen Titel hinzu, der Ihre Community beschreibt',
          input_title: 'Titel',
          input_title_error: 'Maximal 50 Zeichen',
          input_description: 'Beschreibung',
          task_description: 'Beschreiben Sie, was diese Community so interessant, wertvoll, oder wichtig macht.',
          input_description_error: 'Maximal 1000 Zeichen'
        },
        finalize: {
          nav_title: 'Abschließen',
          title: 'Informationen',
          task_title: 'Vielen Dank für das Eingeben dieser Informationen. Wenn Sie auf «Weiter» klicken, schließen wir das Erstellen Ihrer Community ab. Um Themen mit Ihrer Community zu diskutieren, können Sie eine Diskussion eröffnen. Klicken Sie auf die 3 Punkte rechts neben «Diskussionen», um eine neue Diskussion hinzuzufügen.'
        }
      }
    },
    pledge: {
      count: 'Anzahl der Zusagen',
      part1: 'zugesagt von',
      part2: 'Ziel',
      question: 'Würden Sie Mittel aus Ihrem virtuellen Naturbudget für dieses Projekt <b>zusagen</b>?',
      yes: 'Ja, ich möchte Mittel <b>zusagen</b>',
      no: 'Nein, ich möchte <b>keine</b> Mittel zusagen'
    },
    add_pledge: {
      title_nav: 'Zusage hinzufügen',
      title: 'Geben Sie den Betrag an, den Sie gerne für die Finanzierung dieses Projektes zusagen würden.',
      description: 'todo text',
      // Finn's Comment: ??
      amount: 'Beitragshöhe',
      reason: 'Bitte erläutern Sie, warum Sie sich für diesen Betrag entschieden haben.',
      reasonNo: 'Bitte erläutern Sie, warum Sie sich gegen eine Zusage von Mitteln für dieses Projekt entschieden haben.',
      confirm_text1: 'Sie möchten derzeit',
      confirm_text2: 'Ihres angegebenen jährlichen Naturbudgets für dieses Projekt bereitstellen. Können Sie diesen Betrag bestätigen?',
      confirm: 'Ich bestätige'
    },
    add_treasure: {
      title_nav: 'Fügen Sie einen Schatz hinzu',
      photos: 'Fotos',
      title: 'Fotos vom Schatz hochladen',
      description: 'Beschreiben Sie, warum Ihnen dieser Ort gefällt. Teilen Sie eine Zeichnung, ein Gedicht, ein Bild oder eine Kurzgeschichte.',
      upload: 'Foto hochladen (.jpg)'
    },
    create_pledge: {
      title_nav: 'Zusage hinzufügen',
      title: 'Beschreiben Sie Ihre Finanzierungszusage mit einem einprägsamen Titel.',
      description: 'Beschreiben Sie Ihre Finanzierungszusage genauer. Geben Sie Hintergrundinformationen, vorgeschlagene Maßnahmen, erwartete Ergebnisse und was Ihre Unterstützer im Gegenzug erhalten.',
      type: 'Art der Zusage',
      fixed: 'Fixiert',
      fixed_desc: 'Zusage einmalig anfragen',
      yearly: 'Jährlich',
      yearly_desc: 'Jährlich wiederholende Zusagen anfragen.',
      '2yearly': '2-Jährlich',
      '2yearly_desc': 'Zusagen alle zwei Jahre anfragen.',
      '3yearly': '3-Jährlich',
      '3yearly_desc': 'Zusagen alle drei Jahre anfragen.',
      '4yearly': '4-Jährlich',
      '4yearly_desc': 'Zusagen alle vier Jahre anfragen.',
      '5yearly': '5-Jährlich',
      '5yearly_desc': 'Zusagen alle fünf Jahre anfragen.',
      goal: 'Legen Sie die Höhe der Finanzierungszusage in Euros fest.'
    },
    edit_pledge: {
      title_nav: 'Finanzierungszusage bearbeiten'
    },
    create_message: {
      title_nav: 'Create message',
      steps: {
        community: {
          nav_title: 'Community',
          title: 'NOT USED'
        },
        message: {
          nav_title: 'Message'
        },
        finalize: {
          nav_title: 'Finalize'
        }
      }
    },
    create_thread: {
      title_nav: 'Diskussion erstellen',
      title_nav_edit: 'Diskussion bearbeiten',
      title: 'Geben Sie einen Titel an',
      description: 'Verfassen Sie einen ersten Post',
      upload: 'Foto hochladen (.jpg)'
    },
    create_poll: {
      title_nav: 'Umfrage erstellen',
      title_nav_edit: 'Umfrage bearbeiten',
      title: 'Geben Sie einen Titel an',
      description: 'Verfassen Sie einen ersten Post',
      upload: 'Foto hochladen (.jpg)',
      options: 'Umfrage hinzufügen',
      option: 'Optionen'
    },
    create_polis: {
      title_nav: 'Polis erstellen',
      title_nav_edit: 'Polis bearbeiten',
      title: 'Titel hinzufügen',
      id: 'Polis ID hinzufügen',
      voter_option: 'Nur abonnierte Benutzer*innen können abstimmen.'
    },
    create_meeting: {
      title_nav: 'Treffen erstellen',
      title_nav_edit: 'Treffen bearbeiten',
      title: 'Titel hinzufügen',
      description: 'Beschreibung hinzufügen',
      url: 'Fügen Sie einen externen URL für das Treffen hinzu.',
      dateTime: 'Startzeit und Datum'
    },
    meeting: {
      total_subs: 'Anzahl der Abonnent*innen',
      accepted_invites: 'Angenommene Einladungen',
      rejected_invites: 'Abgelehnte Einladungen',
      planned_label: 'geplant am',
      invited_banner: 'Sie wurden zum Meeting eingeladen',
      accepted_banner: 'Sie haben die Einladung angenommen. Wenn Sie ausgewählt werden, erhalten Sie eine E-Mail mit weiteren Einzelheiten zum Treffen.',
      rejected_banner: 'Sie haben die Einladung zum Meeting abgelehnt',
      send_banner: 'Senden Sie den Link zum Treffen an Abonnent*innen, die die Einladung angenommen haben.',
      resend_banner: 'Senden Sie den Link zum Treffen erneut. Achtung, Sie haben den Link bereits gesendet!' // Finn's Comment: This was misspelled in the English version.

    },
    landing: {
      my_portal: 'Mein Xena'
    },
    welcome: {
      title: 'Willkommen bei Greenmapper',
      introduction: 'Einleitung',
      subtitle_1: 'Natur- und Landschaftsorte markieren',
      paragraph_1: 'In Greenmapper Friends können markieren Sie <b>Natur- oder Landschaftsorte</b> mit <b>Grün und/oder Wasser</b>, der für Sie <b></b>attraktiv, wertvoll oder wichtig</b> sind. Der Ort kann klein oder groß sein, in oder außerhalb einer Stadt oder eines Dorfes. Sie können ihn oft besuchen, selten besuchen oder ihn vor allem aus Geschichten oder Fotos kennen.',
      subtitle_2: 'Warum registrieren?',
      paragraph_2: 'Ihr markierter Ort ist ein Ort, dessen <b>Online-Freund</b> Sie sein können. Deshalb fragen wir einige Angaben ab, um ein Konto zu erstellen. Nur Ihr <b>Anzeigename</b> ist für andere sichtbar.',
      subtitle_3: 'Datenschutzrichtlinie',
      paragraph_3: 'Greenmapper Friends ist eine Initiative der Universität Groningen. Greenmapper Friends speichert Ihre E-Mail-Adresse im Greenmapper Landscape Friend Registry (GLFR). Niemand außer der Greenmapper-Organisation kann auf diese E-Mail zugreifen. Sie können über das GLFR anonym von Grundeigentümer*innen, Landverwalter*innen oder anderen Freund*innen der Region erreicht werden. Diese Dritten haben jedoch keinen direkten Zugriff auf Ihre E-Mail. Wir befolgen die Richtlinien der Europäischen Datenschutz-Grundverordnung zum Datenschutz und zur Speicherung Ihrer personenbezogenen Daten.',
      continue_without_account: 'Ohne Konto fortfahren',
      login_text: 'Falls Sie schon ein Konto haben, können Sie sich hier anmelden',
      forgot_password: 'Passwort vergessen?',
      forgot_password_dialog: 'Bitte geben Sie Ihre E-Mail Adresse ein.'
    },
    introduction: {
      title: 'Einführung',
      text: 'In Greenmapper Friends können Sie <b>Natur- oder Landschaftsorte markieren</b>, die Sie <b>attraktiv, wertvoll oder wichtig</b> finden. Diese Bereiche müssen Orte mit Grün, Wasser oder Natur sein. Dies kann ein Ort in einem Park, an einem See, am Meer, in einem Wald oder auf einer Wiese sein. Es könnte ein Blumenfeld, oder ein Platz zum Vogelbeobachten sein. Es kann ein Ort innerhalb oder außerhalb einer Stadt oder Dorf sein; klein oder groß. Sie können den Ort oft besuchen oder fast nie! Es muss sich nur um einen Ort mit Natur handeln, den Sie schön oder wertvoll finden oder der für Sie von Bedeutung ist.',
      start_btn: 'Umfrage starten'
    },
    register: {
      email_sublabel: 'für andere nicht sichtbar',
      name_sublabel: 'für andere sichtbar',
      name_hint: 'zum Beispiel ein Spitzname oder Vornam',
      address_search_sublabel: '±200 m bei Ihrem Zuhause reichen',
      password_hint: 'mindestens 8 Zeiche',
      map_preview_hint: 'Wählen Sie einen Standort, um ihn auf der Karte zu sehen',
      use_my_location: 'Meinen Standort verwenden',
      geolocate_failed: 'Standort konnte nicht ermittelt werden. Prüfen Sie die Berechtigung oder suchen Sie manuell.',
      location_not_found: 'Kein Standort gefunden. Versuchen Sie Stadt, Adresse oder Postleitzahl.',
      disclaimer_title: 'Disclaimer Greenmapper Friends',
      disclaimer: 'Greenmapper Friends speichert Ihre E-Mail-Adresse im Greenmapper Landscape Friend Registry (GLFR). Niemand außer der Greenmapper-Organisation kann auf diese E-Mail zugreifen. Sie können über das GLFR anonym von Grundeigentümern, Landverwaltern oder anderen Freund*innen der Region erreicht werden. Diese Dritten haben jedoch keinen direkten Zugriff auf Ihre E-Mail. Wir befolgen die Richtlinien der Europäischen Datenschutz-Grundverordnung zum Datenschutz und zur Speicherung Ihrer personenbezogenen Daten. Lesen Sie mehr dazu '
    },
    info_contact: {
      title: 'Über uns',
      contact: 'Kontaktieren',
      disclaimer_title: 'Disclaimer',
      implementation: 'Umsetzung: '
    },
    map: {
      title: 'Gesamtkarte der Community',
      add_btn: 'Markieren Sie ein neues Gebiet',
      share_title: 'Karten-URL teilen',
      share_btn: 'In die Zwischenablage kopieren',
      hint_on_add: 'Fügen Sie einen Punkt zur Karte hinzu um mit dem Zeichnen anzufangen',
      hint_on_end_draw: 'Sie können das Gebiet immernoch bearbeiten',
      zoom_to_area_btn: 'Zum Gebiet zoomen',
      details_btn: 'Details ansehen' // share_desc: 'Share'

    },
    timeline: {
      title: 'Zeitachse',
      hint: 'Wussten Sie, dass Wandern die beliebteste Aktivität in Lieblingsnaturgebieten ist?',
      rating: 'Bewertung',
      rating_subtext: 'Persönliche Bewertung der markierten Gebiete',
      visit_frequency: 'Besuchshäufigkeit',
      visit_frequency_subtext: 'Wie oft Sie dieses Gebiet besuchen',
      activities: 'Aktivitätsart',
      activities_subtext: 'Art der Aktivitäten im Gebiet',
      add_btn: 'Gebiet hinzufügen',
      edit_btn: 'Gebiet bearbeiten',
      delete_btn: 'Gebiet löschen',
      delete_title: 'Gebiet löschen',
      delete_subtitle: 'Sind Sie sicher?'
    },
    add_area_info: {
      title: 'Gebiet hinzufügen',
      add_btn: 'Gebiet hinzufügen'
    },
    my_areas: {
      title: 'Meine Gebiete',
      sub_title: 'Alle Naturorte, die ich schön, wertvoll oder wichtig finde',
      created_areas: 'Markierte Gebiete',
      joint_surface: 'Gesamtfläche (km²)',
      and_section_eyebrow: 'Greenmapper-Datenbank Attraktive Natur',
      and_section_title: 'Ihre vier Lieblingsorte nach Maßstab',
      and_complete_badge: 'Alle vier Maßstäbe vollständig',
      free_section_title: 'Selbst hinzugefügte Orte'
    },
    my_communities: {
      title: 'Meine Communities',
      sub_title: 'Alle Gebiete von Grundstückseigentümer*innen oder Gebietsverwalter*innen, die sich mit meinen Bereichen überschneiden. Hier sind Sie als Freund*in dieser Bereiche erreichbar.',
      delete_btn: 'Abmelden',
      delete_title: 'Abmelden',
      delete_subtitle: 'Sind Sie sicher, dass Sie sich von dieser Community abmelden möchten?',
      befriended_communities: 'Befreundete Communities',
      joint_surface: 'Gesamtfläche (km²)'
    },
    info: {
      text1: 'Greenmapper Friends wurde von Greenmapper entwickelt. Weitere Informationen finden Sie im Greenmapper.',
      text2: 'Wenn Sie Fragen haben oder mit uns Kontakt aufnehmen möchten, senden Sie uns bitte eine E-Mail an:',
      text3: 'Bei Greenmapper Friends versuchen wir, die App und die Daten so genau und fehlerfrei wie möglich zu halten. Sollte die App trotz unserer Bemühungen unvollständige oder ungenaue Informationen enthalten, können wir hierfür keine Verantwortung übernehmen.',
      text4: 'Wir behalten uns das Recht vor, Inhalte ohne vorherige Ankündigung zu ändern, zu entfernen oder hinzuzufügen. Greenmapper Friends übernimmt keine Haftung für die Inhalte von Webseiten, auf die wir per Link verweisen.'
    },
    my_owned_communities: {
      title: 'Meine Communities',
      owned_communities: 'Eigene Communities',
      total_subs: 'Anzahl der Abonnent*innen',
      joint_surface: 'Gesamtfläche (km²)'
    },
    community: {
      report_title: 'Kommentar melden',
      report_subtitle: 'Sind Sie sicher, dass Sie diesen Kommentar an die Moderation melden möchten?',
      report_hint: 'Benennen Sie einen Grund',
      delete_title: 'Inhalt löschen',
      delete_subtitle: 'Sind Sie sicher, dass sie diesen Inhalt löschen möchten?',
      discussions_title: 'Diskussionen',
      discussions_subtitle: 'Offene Diskussionen zu jedem Thema',
      poll_title: 'Umfrage',
      poll_subtitle: 'Einfache Umfrage',
      polis_title: 'Pol.is',
      polis_subtitle: 'Fortschrittliche, interaktive Umfragen mit Stellungnahme zu Aussagen Pol.is',
      pledges_title: 'Zusagen',
      pledges_subtitle: 'Virtuelle Geldzusagen für Biodiversität, Landschaftsqualität, oder nachhaltige Dienste Ausführlicher Online-Workshop oder Treffen mit Freund*innen',
      meetings_title: 'Treffen',
      meetings_subtitle: 'Ausführlicher Online-Workshop oder Treffen mit Freund*innen',
      RMS_dialog_title: 'Moderator*innenstatus anfordern',
      RMS_dialog_text: 'Möchten Sie eine Anfrage senden, um Moderator*in dieser Community zu werden?'
    },
    polis: {
      text: 'Klicken Sie auf "Übersetzung ausschalten", um die Kommentare in Ihrer Originalsprache anzuzeigen. Für jede Aussage können Sie mit „Ich stimme zu“, „Ich stimme nicht zu“ oder „Weiter / Ich bin mir unsicher“ stimmen.',
      text2: 'Sie können Ihre Meinung oder Aussage einreichen, damit andere über Ihre Ideen abstimmen können.'
    },
    account: {
      edit_title: 'Profil bearbeiten',
      edit_text: 'Aktuelle Profilinformationen bearbeiten',
      edit_btn: 'Profil bearbeiten',
      signout_title: 'Ausloggen',
      signout_text: 'Aus dem Account ausloggen',
      signout_btn: 'Ausloggen'
    },
    set_home: {
      title: 'Wohnort',
      popup_title: 'Wo wohnen Sie?',
      popup_text: 'Ziehen Sie die Stecknadel in die Nähe Ihres Hauses (±200 m).'
    },
    create_area: {
      title: 'Gebiet erstellen',
      add_title: 'Gebiet hinzufügen',
      stop_title: 'Registrierung stoppen und später beenden',
      pauze_title: 'Bist du sicher?',
      pauze_text: 'Registrierung unterbrechen und später abschließen',
      map_tips: 'Kartentipps',
      search_place: 'Ort suchen',
      search_not_found: 'Nichts gefunden',
      zoom_smaller: 'Kleiner',
      zoom_bigger: 'Größer',
      area_reset: 'Gebiet zurückgesetzt',
      reset_polygon: 'Polygon zurücksetzen',
      reset_polygon_title: 'Polygon zurücksetzen?',
      reset_polygon_text: 'Damit wird das Polygon wieder so hergestellt, wie es vor dem Bearbeiten aussah.',
      leave_polygon_edit_title: 'Polygonbearbeitungen verlassen?',
      leave_polygon_edit_text: 'Wenn du zurückgehst, wird das Polygon wieder zur Kreisauswahl. Deine Punktänderungen gehen verloren.',
      polygon_guard: {
        cross: 'Linien dürfen sich nicht kreuzen',
        spacing: 'Punkte dürfen nicht zu nah beieinander liegen',
        edge: 'Punkt darf einer anderen Seite nicht zu nah kommen',
        angle: 'Ecke darf nicht so spitz werden',
        area: 'Gebiet darf nicht so klein werden',
        bounds: 'Punkt bleibt im sichtbaren Kartenbereich'
      },
      loading: {
        title: 'Karte wird vorbereitet',
        opening: 'Karte wird geöffnet…',
        loading_account: 'Konto wird geladen…',
        loading_areas: 'Ihre Gebiete werden geladen…',
        loading_home: 'Wohnort wird geladen…'
      },
      hints: {
        place_above_area: 'Über Ihrem Gebiet platzieren',
        place_area_here: 'Ort vollständig drin',
        drag_vertex: 'Punkte ziehen für bessere Passform',
        zoom: 'Rein- und rauszoomen',
        at_edge: 'Sie haben den Rand dieses Gebiets erreicht'
      },
      stepper: {
        description: 'Beschreibung',
        rate: 'Bewertung',
        visit_freq: 'Besuchshäufigkeit',
        activities: 'Aktivitätsart ',
        connected: 'Online verbunden'
      },
      steps: {
        level: {
          nav_title: 'Umkreis',
          title: 'Umkreis auswählen',
          task_title: 'Wählen Sie aus, in welchem Umkreis das Gebiet für Sie liegt.',
          options: {
            neighborhood: 'Nachbarschaft',
            living_area: 'Region',
            country: 'Land',
            world: 'Weltweit'
          }
        },
        map: {
          nav_title: 'Karte',
          title: 'Gebiet zeichnen',
          task_title: 'Zeichnen Sie Ihr Gebiet ein.'
        },
        description: {
          nav_title: 'Beschreiben Sie',
          title: 'Beschreibung',
          task_title: 'Wie nennst du dieses Gebiet?',
          input_title: 'Titel',
          input_name: 'Name',
          input_title_error: 'Maximal 50 Zeichen',
          input_description: 'Beschreibung',
          task_description: 'Warum ist dieses Gebiet attraktiv, wertvoll und/oder wichtig?',
          input_description_error: 'Maximal 100 Zeichen'
        },
        rate: {
          nav_title: 'Bewertung',
          title: 'Bewerten Sie Ihr Gebiet',
          task_title: '(Bewertung: 1 = Schlecht, 6 = Mittel, 10 = Perfekt)'
        },
        visit_freq: {
          nav_title: 'Besuchshäufigkeit',
          title: 'Wie oft besuchen Sie Ihr Gebiet?',
          options: {
            daily: 'Täglich',
            weekly: 'Wöchentlich',
            monthly: 'Monatlich',
            few_times_a_year: 'Ein paar Mal pro Jahr',
            yearly: 'Jährlich',
            rarely: 'Manchmal',
            never: 'Nie'
          }
        },
        activities: {
          nav_title: 'Aktivitätsart',
          title: 'Welche Aktivitäten unternehmen Sie in diesem Gebiet?'
        },
        priority: {
          nav_title: 'Priorität',
          title: 'Dieser Ort muss:',
          options: {
            maintained: 'So beibehalten werden',
            strengthened: 'Verbessert werden'
          }
        },
        relationship: {
          nav_title: 'Verbindung',
          title: 'Was ist Ihre Verbindung mit diesem Lieblingsnaturgebiet?',
          options: {
            tourist: 'Tourist',
            inhabitant: 'Anwohner*in',
            work: 'Arbeitsbezogen'
          }
        },

        /*
                        finished: {
                            '1_title': 'Vielen Dank! Ihr erster Ort ist nun auf der Karte eingetragen',
                            '1_text': 'Schon dieser erste Beitrag hilft besser zu verstehen, welche Naturorte Menschen schätzen. Sie können jetzt einen weiteren Ort hinzufügen oder später zurückkehren (über die Schaltfläche oben rechts)',
                            '2_title': 'Sehr gut — Ihre persönliche Karte nimmt langsam Form an',
                            '2_text': 'Jeder hinzugefügte Ort hilft sichtbar zu machen, was Schutz verdient. Sie können jetzt einen weiteren Ort hinzufügen oder später zurückkehren (über die Schaltfläche oben rechts)',
                            '3_title': 'Vielen Dank! Ihr Beitrag liefert bereits wertvolle Erkenntnisse über Natur und Landschaften',
                            '3_text': 'Noch ein Ort macht Ihre Karte vollständig — Sie können aber auch später fortfahren (über die Schaltfläche oben rechts)',
                            '4_title': 'Großartig — Ihre persönliche Karte ist nun vollständig!',
                            '4_text': 'Ihr Beitrag hilft Forschenden und Verantwortlichen besser zu verstehen, welche Orte Menschen erhalten und schützen möchten. Gleich sehen Sie eine Übersicht Ihrer Orte. Zunächst haben wir noch eine kurze Frage zur möglichen finanziellen Unterstützung Ihrer Gebiete'
                        }
        */
        finished: {
          '1_title': 'Vielen Dank! Ihr erster Ort ist nun auf der Karte eingetragen',
          '1_text': 'Schon dieser erste Beitrag hilft besser zu verstehen, welche Naturorte Menschen schätzen.',
          '2_title': 'Sehr gut — Ihre persönliche Karte nimmt langsam Form an',
          '2_text': 'Jeder hinzugefügte Ort hilft sichtbar zu machen, was Schutz verdient.',
          '3_title': 'Vielen Dank! Ihr Beitrag liefert bereits wertvolle Erkenntnisse über Natur und Landschaften',
          '3_text': 'Noch ein Ort macht Ihre Karte vollständig.',
          '4_title': 'Großartig — Ihre persönliche Karte ist nun vollständig!',
          '4_text': 'Ihr Beitrag hilft Forschenden und Verantwortlichen besser zu verstehen, welche Orte Menschen erhalten und schützen möchten. Gleich sehen Sie eine Übersicht Ihrer Orte. Zunächst haben wir noch eine kurze Frage zur möglichen finanziellen Unterstützung Ihrer Gebiete'
        }
      },
      _edit: {
        title: 'Gebiet aktualisieren'
      },
      welcome: {
        title: 'Gebiete zeichnen und Fragen beantworten',
        subtitle: 'Markieren Sie vier Naturorte in verschiedenen Maßstäben und erzählen Sie, warum sie Ihnen wichtig sind.',
        sheet_text: 'Sehen Sie sich die Übersicht unten an. Drücken Sie Weiter, um Ihr erstes Nachbarschaftsgebiet zu zeichnen.',
        how_it_works_title: 'Was Sie auf jeder Ebene tun',
        step_draw: 'Markieren Sie ein Gebiet auf der Karte',
        step_questions: 'Fragen zu Ihrem Ort beantworten',
        step_next_level: 'Für 4 Maßstäbe wiederholen',
        journey_title: 'Vier Maßstäbe, vier Orte',
        video_caption: 'Kurze Anleitung zum Zeichnen eines Gebiets'
      },
      welcome_v3: {
        greeting: 'Willkommen bei Greenmapper Friends',
        title: 'Markieren Sie Ihren Naturort',
        intro: 'Markieren Sie Orte mit Grün, Wasser oder Landschaft, die Sie attraktiv, wertvoll oder wichtig finden.',
        levels_title: 'Vier Maßstäbe',
        levels_intro: 'Wählen Sie auf jeder Ebene einen Ort.',
        checklist_title: 'Was Sie auf jeder Ebene tun',
        step_draw: 'Zeichnen Sie den Ort als Gebiet auf der Karte.',
        step_adjust: 'Passen Sie die Form an und bestätigen Sie das Gebiet.',
        step_questions: 'Beantworten Sie einige Fragen dazu, warum Ihnen dieser Ort wichtig ist.',
        step_repeat: 'Wiederholen Sie diese Schritte für die nächste Maßstabsebene.',
        repeat_hint: 'Sie beginnen in Ihrer Nachbarschaft. Nach den Fragen folgen Region, Land und Welt.',
        start_btn: 'Mit Nachbarschaft starten'
      },
      welcome_v4: {
        title: 'Markieren Sie Ihren Naturort',
        title_next: 'Nächster Ort: {level}',
        intro: 'Markieren Sie Orte mit Grün, Wasser oder Landschaft, die Sie attraktiv, wertvoll oder wichtig finden.',
        intro_next: 'Weiter mit {level}. Markieren Sie einen Ort mit Grün, Wasser oder Landschaft, der Sie attraktiv, wertvoll oder wichtig finden.',
        levels_title: 'Vier Maßstäbe',
        checklist_title: 'Was Sie auf jeder Ebene tun',
        start_badge: 'Start',
        now_badge: 'Jetzt',
        done_badge: 'Fertig',
        progress: 'Ort {current} von 4',
        start_btn: 'Mit {level} starten',
        continue_btn: 'Weiter mit {level}'
      }
    },
    edit_area: {
      title: 'Gebiet aktualisieren'
    },
    funding: {
      title: 'Virtuelle Natur & Community Mittel',
      nav_intro: 'Einleitung',
      nav_amount: 'Höhe',
      nav_locations: 'Orte',
      nav_objectives: 'Ziele',
      nav_finalize: 'Abschließen',
      intro1: 'Hallo!',
      intro2: 'Vielen Dank für Ihre Teilnahme am Greenmapper-Experiment zur Naturfinanzierung.',
      intro3: 'In diesem Abschnitt nutzen Sie den <b>Virtuellen Natur- und Gemeinschaftsfonds</b>. Sie zeigen, wie Sie ein <b>hypothetisches</b> jährliches Naturbudget verteilen würden — <b>ohne tatsächlich zu bezahlen</b>. Zusammen mit anderen Teilnehmenden hilft das Verantwortlichen und politischen Entscheidungsträgern zu verstehen, was Menschen wichtig finden.',
      intro4: '<h6>So funktioniert es in 3 Schritten:</h6>',
      step1: 'Gesamtbudget pro Jahr bestätigen',
      step2: 'Auf Ihre 4 Gebiete verteilen',
      step3: 'Pro Gebiet auf Ziele verteilen: Biodiversität, Landschaft, nachhaltiges Wirtschaften, Kultur, Sonstiges',
      caption: 'Stamm = Gebiet • Äste = Ziele • Äpfel = Beispiel-Projekte.',
      intro5: '<b>Praktisch</b>: 5–8 Min • anonym • keine richtigen/falschen Antworten.',
      intro6: 'Als Dank <b>spenden wir 5 € für die Natur auf Texel,</b> obald Sie diesen Abschnitt abgeschlossen haben.',
      amount1: 'Virtueller Finanzierungsbetrag',
      amount2: 'Wie viel würden Sie – wenn Sie es könnten – jährlich für Ihre Lieblingsnaturgebiete ausgeben? Dieser Betrag ist fiktiv, aber versuchen Sie, eine realistische Wahl zu treffen.',
      amount3: 'Geben Sie unten Ihr (virtuelles) jährliches Naturschutzbudget ein.',
      amount4: 'Erläutern Sie kurz, warum Sie diesen Betrag gewählt haben. Was ist Ihnen, zum Beispiel, besonders wichtig zu unterstützen? Wie haben Sie diesen Betrag ermittelt?',
      amount5: 'Jahresbudget',
      max: 'Maximum Betrag 5000 euro',
      min: 'Minimum Betrag 1 euro',
      locations1: 'Weisen Sie Ihren Lieblingsnaturgebieten ein Budget zu',
      locations2: 'Geben Sie an, wie Sie Ihr gewähltes (virtuelles) Budget auf die virtuellen Natur- und Gemeinschaftsfonds Ihrer bevorzugten Naturgebiete verteilen würden.',
      locations3: 'Können Sie kurz erläutern, warum Sie sich für diese Aufteilung entschieden haben?',
      objectives1: 'Budgetverteilung auf die Finanzierungszwecke',
      objectives2: 'Hier sehen Sie Ihre Mittelzuweisung für die virtuellen Natur- und Gemeinschaftsfonds in Ihrem gewählten Gebiet. Sie können dies für Ihre Lieblingsgebiete in Ihrer Nachbarschaft, Ihrer Region, Ihrem Land und weltweit tun. Geben Sie an, wie Sie Ihr Budget auf die vier Ziele verteilen würden:',
      objectives2a: 'Wenn Sie etwas unterstützen möchten, das nicht in eine dieser Kategorien passt, tragen Sie es bitte unten unter „Sonstiges“ ein und weisen Sie der Kategorie einen Teil Ihres Budgets zu.',
      objectives3: 'Könnten Sie kurz erläutern, warum Sie sich für diese Zielverteilung entschieden haben? Warum haben Sie sich für diese Aufteilung entschieden?',
      biodiversity_title: 'Biodiversitätsschutz',
      biodiversity_text: 'Eine reiche Artenvielfalt trägt zum Funktionieren von Ökosystemen bei und ist entscheidend für den Erhalt allen Lebens auf der Erde. Projekte zum Schutz der biologischen Vielfalt zielen darauf ab, die biologische Vielfalt, oft ganz lokal, zu verbessern oder zu erhalten. Solche Projekte können zum Beispiel die Verbesserung der Boden- und Wasserqualität oder die Installation von Nistkästen für Vögel sein.',
      ALC_title: 'Landschaftsqualität und Aussicht',
      ALC_text: 'Ein schönes Landschaftsbild bezieht sich auf die Aussicht und den Genuss einer Landschaft. Ein solches Projekt kann den Schutz oder die Wiederherstellung von Landschaftselementen wie Hecken, die Renaturierung der Landschaft, oder die Schaffung von Wander- oder Radwegen durch die Landschaft umfassen.',
      SUSBUS_title: 'Nachhaltiges Unternehmertum',
      SUSBUS_text: 'Nachhaltige Unternehmen üben ihre Wirtschaftstätigkeit aus, ohne negative Auswirkungen auf ihre (lokale) Umwelt zu verursachen. Projekte, die auf mehr Nachhaltigkeit in der lokalen Wirtschaft abzielen, können den Übergang von einem konventionellen Bauernhof zu einem biologischen oder naturintegrierten Bauernhof beinhalten. Es kann sich auch um den Aufbau eines Netzwerks lokaler Unternehmen und Organisationen handeln, die Abfall und Umweltverschmutzung durch Zusammenarbeit reduzieren.',
      finalize1: '<b>Danke!</b><br> Vielen Dank für deine Teilnahme an dieser Studie zur Naturfinanzierung der Rijksuniversiteit Groningen. Deine Antworten sind für uns sehr wertvoll. Klicke auf <b>Speichern</b>, um deine Antworten zu sichern.',
      finalize1A: '<b>Hurra!</b><br> Du hast 10 € für Naturprojekte auf Texel verdient. Vielen Dank — dein Beitrag hilft uns zu verstehen, wie Menschen die Natur unterstützen möchten.',
      finalize1B: '<b>Was passiert jetzt?</b><br> Du gehst nun zur Greenmapper Friends-Community „Nationalpark Dünen von Texel“ für Teil 3. Dort bewertest du sechs echte Finanzierungsanfragen. Gib für jedes Projekt an, ob du es unterstützt und warum.\n' + 'Dein eigener Beitrag in diesem Experiment ist fiktiv, aber die Spenden von 10 € und 5 € in deinem Namen sind echt.',
      finalize1C: '<b>Zusätzliche Belohnung für Texel</b><br> Wenn du auf alle sechs Anfragen reagierst, spendet Greenmapper weitere 5 €. Jede Reaktion zählt! Nach der Beantwortung aller sechs Anfragen nimmst du automatisch an der Verlosung teil.',
      finalize2: 'Bitte beachten Sie, dass ein Widerruf Ihrer übermittelten Daten ohne Folgen möglich ist. Wenn Sie dies tun möchten oder andere Fragen zur Forschung haben, senden Sie bitte eine E-Mail an j.beverdam@rug.nl.',
      cultural_title: 'Kultur und Gemeinschaftsleben',
      cultural_text: 'Naturgebiete können auch ein kulturelles Erbe oder andere kulturelle Aspekte enthalten. Beispielsweise, wenn historische Gebäude oder Denkmäler vorhanden sind oder bestimmte kulturelle Ereignisse damit verbunden sind. Kulturprojekte können die Organisation von (Musik-)Veranstaltungen, Bildungsausflügen oder die Erhaltung von landschaftlichem Erbe beinhalten.',
      other_title: 'Weiteres',
      other_text: 'Möchten Sie noch etwas in Ihrem Lieblingsnaturgebiet fördern, das oben aber nicht genannt wurde? Dann nennen Sie es doch selbst! Mit diesem Schieberegler können Sie angeben, wie viel von Ihrem Budget Sie dafür zur Verfügung stellen würden. Dies ist nicht verpflichtend, sondern nur falls Ihnen etwas einfällt, das nicht in die vorherigen Förderzielkategorien passt.',
      placeholder: 'Weiteres, namentlich'
    }
  },
  drawer: {
    area_section: 'Entdecken',
    my_section: 'Meine Übersicht',
    other_section: 'Weiteres',
    edit_funding: 'Mein Naturbudget',
    per_year: '/jahr',
    messages: 'Nachrichten'
  },
  mail: {
    inbox: 'Posteingang',
    outbox: 'Postausgang',
    compose: 'Verfassen'
  },
  gender: {
    male: 'Männlich',
    female: 'Weiblich',
    other: 'Divers'
  },
  education: {
    1: 'Weniger als Hochschulreife',
    2: 'Hochschulreife',
    3: 'Hochschule ohne Abschluss',
    4: 'Hochschulabschluss',
    5: 'Bachelor',
    6: 'Master',
    7: 'Berufsschulabschluss/ Abgeschlossene Lehre',
    8: 'Doktortitel'
  },
  texel: {
    'continue-funding-1': 'Sie haben sich kürzlich für Greenmapper Friends registriert. Vielen Dank für Ihre Bereitschaft, an dieser Studie über finanzielle Unterstützung für die Natur teilzunehmen. Neben Ihren wertvollen Antworten für die Forschung spenden wir pro abgeschlossener Teilnahme 15 € an Naturprojekte auf Texel (bis zu maximal 2.000 €). Das Experiment dauert zwischen 5 und 10 Minuten. Bitte stellen Sie sicher, dass Sie im zweiten Teil der Studie auf alle virtuellen Finanzierungsanfragen reagieren, um die Teilnahme vollständig abzuschließen.',
    'continue-funding-2': 'Klicken Sie auf „Weiter“, um zur Einführung der Studie zu gelangen.',
    'continue-funding-3': 'Wir möchten uns herzlich für Ihre wertvolle Teilnahme an der Greenmapper Friends-Plattform bedanken.',
    'continue-register-1': 'Sie haben kürzlich den Registrierungsprozess für Greenmapper Friends gestartet, aber noch nicht abgeschlossen. Vielen Dank für Ihre Bereitschaft, Ihre Registrierung zu vervollständigen. Ihr Beitrag über Ihre bevorzugte Natur ist von großer Bedeutung für Forscher und Entscheidungsträger.',
    'continue-register-2': 'Klicken Sie auf „Weiter“, um Ihren Registrierungsprozess fortzusetzen.',
    'continue-register-3': 'Wir möchten uns herzlich für Ihre wertvolle Teilnahme an der Greenmapper Friends Plattform bedanken.'
  },
  video: {
    'draw_popup_title_1': 'Nachbarschaft',
    'draw_popup_subtitle_1': 'Innerhalb von 2 km von zu Hause',
    'draw_popup_text_1': 'Diese Karte zeigt ein Gebiet von 2 km um Ihren Wohnort. Markieren Sie einen naturnahen Ort innerhalb dieser 2 km, der für Sie attraktiv, wertvoll oder wichtig ist. Wenn Sie keinen Ort innerhalb des 2-km-Umkreises kennen, markieren Sie bitte ein Gebiet, das so nah wie möglich daran liegt.',
    'draw_popup_title_2': 'Region',
    'draw_popup_subtitle_2': 'Innerhalb von 20 km von zu Hause',
    'draw_popup_text_2': 'Diese Karte zeigt ein Gebiet von 20 km um Ihren Wohnort. Markieren Sie einen naturnahen Ort innerhalb dieser 20 km, der für Sie attraktiv, wertvoll und wichtig ist.',
    'draw_popup_title_3': 'Land',
    'draw_popup_subtitle_3': 'Ganzes Land',
    'draw_popup_text_3': 'Diese Karte zeigt eine Karte der Niederlande. Markieren Sie naturnahen einen Ort auf dieser Karte, der für Sie attraktiv, wertvoll oder wichtig ist.',
    'draw_popup_title_4': 'Welt',
    'draw_popup_subtitle_4': 'Weltweit',
    'draw_popup_text_4': 'Diese Karte zeigt eine Weltkarte. Markieren Sie einen naturnahen Ort auf dieser Karte, der für Sie attraktiv, wertvoll oder wichtig ist.',
    'draw_popup_video': 'Unten sehen Sie ein kurzes Video (30 Sek.) darüber, wie man ein Gebiet zeichnet.',
    'step1_helper': 'Verschieben Sie die Karte, bis Ihr attraktiver Ort vollständig im klaren Kreis liegt. Zoomen Sie, bis der Kreis ihn ganz abdeckt.',
    'step2_helper': 'Sieht es gut aus? Weiter — oder ziehen Sie optional die Punkte, damit die Form Ihren Ort besser abdeckt.',
    'clamp_hint_default': 'Dies bleibt innerhalb von {distance}. Bei der nächsten Frage können Sie weiter gehen.',
    'scale_badge_radius': 'Innerhalb von {distance} von zu Hause',
    'scale_badge_full': 'Auf der Karte von {name}',
    'level_up_toast': 'Gebiet vergrößert auf {distance}'
  }
};